import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { merge } from 'lodash';
import { useLayoutEffect, useMemo, useRef } from 'react';

interface IProps {
  defaultOptions: Highcharts.Options;
  isLoading?: boolean;
}

const PieChart = ({ defaultOptions, isLoading }: IProps) => {
  const ref = useRef<HighchartsReact.RefObject>(null);

  useLayoutEffect(() => {
    const chart = ref.current?.chart;
    if (chart) {
      if (isLoading) {
        chart.showLoading();
      } else {
        chart.hideLoading();
      }
    }
  }, [isLoading]);
  const options: Highcharts.Options = merge(
    {
      chart: {
        type: 'pie',
      },
      title: {
        text: null,
      },
      series: [
        {
          type: 'pie',
          innerSize: '70%',
        },
      ],
    },
    defaultOptions,
  );

  return useMemo(
    () => <HighchartsReact ref={ref} highcharts={Highcharts} options={options} />,
    [JSON.stringify(options), isLoading],
  );
};

export default PieChart;
